import type { Notification } from "@/entities/notification/model";
import type { User } from "@/entities/user";
import type { VersionedField } from "@/shared/types";

export interface Offer {
  _id: string;
  name: string;
  description: VersionedField<string>;
  extra: VersionedField<string | null>;
  sender: User;
  receiver: User;
  status: OfferStatus;
  createdAt: string;
  updatedAt: string;
  notifications: Notification[];
}

export enum OfferStatus {
  PENDING = "pending",
  COMPLETED = "completed",
  REJECTED = "rejected",
  IN_PROGRESS = "in_progress",
  DISPUTE = "dispute",
  WAITING_FOR_COMPLETE = "waiting_for_complete",
  CLOSED_AFTER_DISPUTE = "closed_after_dispute",
}
